// 两个新数组按下标配对；旧记录可能没有新字段，或返回空数组。
export function getLinkCovers(link = {}) {
  const urls = Array.isArray(link.rand_picurl) ? link.rand_picurl : []
  const ids = Array.isArray(link.rand_source_material_id) ? link.rand_source_material_id : []
  if (urls.length || ids.length) {
    return Array.from({ length: Math.max(urls.length, ids.length) }, (_, index) => ({
      picurl: urls[index] || '',
      source_material_id: ids[index] == null ? '' : ids[index]
    }))
  }
  if (link.picurl || link.source_material_id) {
    return [{ picurl: link.picurl || '', source_material_id: link.source_material_id == null ? '' : link.source_material_id }]
  }
  return []
}

export function isCompleteLinkCover(cover) {
  const id = cover.source_material_id
  const hasId = typeof id === 'number'
    ? Number.isFinite(id) && id > 0
    : typeof id === 'string' && !!id.trim() && id !== '0'
  return typeof cover.picurl === 'string' && !!cover.picurl.trim() && hasId
}

export function getLinkCoverFields(covers) {
  const first = covers[0]
  return {
    rand_picurl: covers.map(cover => cover.picurl),
    rand_source_material_id: covers.map(cover => cover.source_material_id),
    // 单图字段始终同步第一张，避免换图、删图后留下旧值。
    picurl: first ? first.picurl : '',
    source_material_id: first ? first.source_material_id : ''
  }
}

export function getLinkCoverUrl(link) {
  const first = getLinkCovers(link)[0]
  return first ? first.picurl : ''
}
